import { UserPermission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import * as userSlice from '../../data/user.slice';
import { useHasPermission } from './useHasPermission';

export const useCanReadSettings = (): boolean => {
  const user = useAppSelector(userSlice.selectLoggedInUserInfo);

  const readPermissionAll: UserPermission = {
    resource: 'settings',
    action: 'readbasic',
    scope: 'all',
  };

  const canReadAll = useHasPermission(user, readPermissionAll);
  return canReadAll;
};
